import React, {useState} from 'react';
import Axios from 'axios';
import "../contactform.css";

const ContactForm = () => {

    const[formData, setFormData] = useState({
        fullName: "",
        email: "",
        phoneNumber: "",
        description: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value})
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log('Form being submited:', formData)
        try {
            const response = await Axios.post('/api/submit', formData);
            
            if (response.status === 200) {
                alert('Form has been sent');
                setFormData({
                    fullName: "",
                    email: "",
                    phoneNumber: "",
                    description: ""
                });
            } else {
                // If the response status isn't 200, show an alert with the message
                alert("Failed to submit form. Please try again.");
            }
        } catch (error) {
            console.error("Form submission error", error);
            // Improved error handling for response errors
            if (error.response) {
                // If the error has a response (e.g., 400 or 500)
                console.error("Error response:", error.response);
                if (error.response.data && error.response.data.message) {
                    alert(error.response.data.message); // Show server-side message
                } else {
                    alert("Server returned an error. Please try again later.");
                }
            } else if (error.request) {
                // If no response is received (network issues, etc.)
                console.error("No response received:", error.request);
                alert("No response from the server. Check your connection and try again.");
            } else {
                // General errors (request setup errors, etc.)
                console.error("Error message:", error.message);
                alert("Unexpected error occurred: " + error.message);
            }
        }
    };

    return (
    <section  className="contact-section">
        <div className="contact-container" id="dlc_form">
        {/* Header Text */}
        <div className="contact-header">
            <h1>Start Your Project Today</h1>
            <p>Fill out the form below and we'll get back to you within 24 hours</p>
        </div>

        {/* Form Card */}
        <form className="contact-form-card" id="form" onSubmit= {(e) => handleSubmit(e)}>
            <div className="form-row">
            <div className="form-group">
              <label>Full Name *</label>
                <input type="text" placeholder="John Doe" name='fullName' required value={formData.fullName} onChange={handleChange}/>
            </div>
            <div className="form-group">
              <label>Email Address *</label>
                <input type="email" placeholder="john@example.com" name='email' required value={formData.email} onChange={handleChange}/>
            </div>
            </div>

            <div className="form-group">
            <label>Phone Number</label>
            <input type="tel" placeholder="(555) 123-4567" name='phoneNumber' value={formData.phoneNumber} onChange={handleChange}/>
            </div>

            <div className="form-group">
            <label>Project Details *</label>
            <textarea 
                placeholder="Tell us about your dream home project..." 
                rows="5" 
                required
                value={formData.description}
                onChange={handleChange}
                name='description'
            ></textarea>
            </div>

            <button type="submit" className="submit-btn">
            Send Message <span>&rarr;</span>
            </button>
        </form>
        </div>
    </section>
    )
}

export default ContactForm;










